export const mapPopupToApproverRow = (p: any) => {
  // Helper to safely pick a value with graceful fallback
  const pick = (...keys: string[]) => {
    for (const k of keys) {
      const v = p?.[k];
      if (v !== undefined && v !== null && String(v).trim() !== "") return v;
    }
    return ""; // default empty
  };

  
  return {
    
    "Approval status": pick("lineStatus"),  
    "IO Run Type": pick("ioRunTypeLabel"), 
    "Approval Required":pick("approval_required"),                     
    "Approver": pick("approver", "Approver"),                    // if you populate approver later
    "End User": pick("endUser", "End User"),                     // optional; set if available
    "Material Plant": pick("Material Plant", "materialPlant"),
    "Material Number": pick("Material Number", "materialNumber", "id"),
    "Material Description": pick("Material Description", "materialDescription"),

    // Actions (these depend on your selection logic)
    "End User action": pick("End User action", "endUserAction", "selectedChoice?.choice", "choice"),
    "Reason": pick("Reason", "reasonCode", "reason"),
    "Comments": pick("Comments", "comments"),

    // —— Group: End User proposal —— (from popup's submitted fields)
    "Total consolidated Safety Stock (weeks)": pick(
      "Total consolidated Safety Stock (weeks)",
      "iOConsolidatedSafetyStock(wk)-Rounded",
      "IO Consolidated Safety Stock (wk) - Rounded"
    ),
    "Safety Time (weeks)": pick(
      "Safety Time (weeks)",
      "Safety Time (wk) - End User Proposal",
      "safetyTime" // if Manual Override row was chosen and saved into selectedChoice
    ),
    "Coverage Profile (weeks)": pick(
      "Coverage Profile (weeks)",
      "Coverage Profile (wk) - End User Proposal",
      "coverageProfile" // from selectedChoice when Manual Override
    ),
    "Safety Stock (qty)": pick(
      "Safety Stock (qty)",
      "Safety Stock (Qty) - End User Proposal",
      "safetyStock" // from selectedChoice when Manual Override
    ),

    // —— Group: Consolidated Safety Stock (weeks) ——
    "IO (weeks)": pick(
      "IO (weeks)",
      "iOCoverage(Weeks)(Rounded)",            // IO coverage weeks
      "IO Coverage (Weeks) (Rounded)"
    ),
    "S4  (weeks)": pick(
      "S4  (weeks)",
      "s4CoverageProfile(wk)",
      "S4 Coverage Profile (wk)"
    ),

    // —— Group: Comparisons ——
    "EU proposal vs IO %": pick("EU proposal vs IO %", "VAR (%) - End User Proposal vs IO", "Variation (%) - End User Proposal vs IO"),
    "EU proposal vs S4 %": pick("EU proposal vs S4 %", "VAR (%) - End User Proposal vs S4", "Variation (%) - End User Proposal vs S4"),

    // —— Approver-stage fields (these may be empty until an approver acts) ——
    "Approver actions": pick("Approver actions", "approverAction"),
    "Consolidated Safety Stock (wk) - Approved": pick("Consolidated Safety Stock (wk) - Approved", "approvedSafetyStockWeeks"),
    "VAR (wk) - Approved SS vs S4": pick("VAR (wk) - Approved SS vs S4", "approvedVsS4VarWk"),
    "VAR (%) - Approved SS vs S4": pick("VAR (%) - Approved SS vs S4", "approvedVsS4VarPct"),
    "VAR (USD) - Approved SS vs S4": pick("VAR (USD) - Approved SS vs S4", "approvedVsS4VarUsd"),
    "VAR (PDR) - Approved SS vs S4": pick("VAR (PDR) - Approved SS vs S4", "approvedVsS4VarPdr"),

    // —— Extras ——
    "Item Type": pick("Item Type", "itemType"),
    "Path": pick("Path", "path"),
    "Weekly Demand (Qty)": pick("Weekly Demand (Qty)", "weeklyDemandQty", "Weekly Demand (Qty)"),
    "End User accepts IO Proposal?": pick("End User accepts IO Proposal?", "endUserAcceptsIO"),
    "Consolidated Safety Stock (USD) - Approved": pick("Consolidated Safety Stock (USD) - Approved", "approvedCssUsd"),
    "Consolidated Safety Stock (USD) - S4": pick("Consolidated Safety Stock (USD) - S4", "s4CssUsd"),
    "Part Units pear EA (PDR/EA)": pick("Part Units pear EA (PDR/EA)", "pdrPerEa", "Part Units per EA (PDR/EA)") // typo tolerant
  };
};
